module.exports = __webpack_public_path__ + "static/media/MobileBackground.6f385037.png";